export default __webpack_public_path__ + "static/banner_net-549d451bf37b0345f0e7abb74a2ac328.webp";